var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNesoColoredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0005 12.0164C22.9989 12.5604 22.9571 13.1035 22.8755 13.6414C22.8167 14.0626 22.7333 14.4799 22.6255 14.8914C22.543 15.1976 22.448 15.4964 22.3405 15.7914C22.1736 16.2489 21.9756 16.6945 21.748 17.1251C20.8746 18.7902 19.5889 20.2036 18.0137 21.2304C16.4386 22.2571 14.6265 22.863 12.7505 22.9901C12.5005 23.0076 12.2505 23.0164 12.0005 23.0164C11.7505 23.0164 11.5005 23.0076 11.2505 22.9901C8.96644 22.8356 6.78746 21.9723 5.01733 20.5206C3.24719 19.0689 1.97411 17.101 1.37552 14.8914C1.26779 14.4799 1.18431 14.0626 1.12552 13.6414C0.901282 12.1398 0.990321 10.608 1.38703 9.14247C1.78374 7.67696 2.47954 6.30944 3.43062 5.12599C4.3817 3.94254 5.56747 2.96879 6.91329 2.26604C8.25911 1.56328 9.73584 1.14673 11.2505 1.04261C11.3193 1.03636 11.388 1.03261 11.4568 1.02886C11.6368 1.01636 11.818 1.01636 12.0005 1.01636C12.2505 1.01636 12.5005 1.02511 12.7505 1.04261C12.8068 1.04261 12.8618 1.04261 12.9168 1.05511C15.6659 1.28489 18.2283 2.53925 20.096 4.5695C21.9637 6.59975 23.0004 9.25768 23.0005 12.0164Z",
    fill: "#840015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 13.6221C22.8162 14.0427 22.7327 14.4595 22.625 14.8703H1.375C1.26727 14.4595 1.18379 14.0427 1.125 13.6221H22.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1.04117V22.9575C12.5 22.975 12.25 22.9837 12 22.9837C11.75 22.9837 11.5 22.975 11.25 22.9575V1.04117C11.3187 1.03493 11.3875 1.03118 11.4563 1.02744C11.6362 1.01495 11.8175 1.01495 12 1.01495C12.25 1.01495 12.5 1.02369 12.75 1.04117Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3348 15.769C22.1679 16.2259 21.9699 16.6709 21.7423 17.1009L20.3148 14.8703L19.5161 13.622L12.7498 3.04956L11.4561 1.02744C11.6361 1.01495 11.8173 1.01495 11.9998 1.01495C12.2498 1.01495 12.4998 1.02369 12.7498 1.04117C12.8061 1.04117 12.8611 1.04117 12.9161 1.05365L20.9611 13.622L21.7598 14.8703L22.3348 15.769Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNesoColoredIcon);
export default __webpack_public_path__ + "static/media/NesoColoredIcon.241e94af.svg";
export { ForwardRef as ReactComponent };